import {FC} from 'react';

import {Box, Typography} from '@mui/material';
import {Trans} from 'react-i18next';

import {IDeliveryOptionProps} from './types';

export const DeliveryOption: FC<IDeliveryOptionProps> = ({
  Icon,
  name,
  eligibleItems,
  totalItems,
  isSelected,
  onClick,
  type
}) => {
  return (
    <Box
      onClick={onClick}
      width={116}
      boxSizing="border-box"
      paddingX={1}
      paddingBottom={1.5}
      paddingTop={2}
      display="flex"
      alignItems="center"
      justifyContent="flex-end"
      flexDirection="column"
      gap={0.25}
      borderRadius={3}
      bgcolor={isSelected ? 'common.mds_global_color_white' : 'none'}
      data-test-id={`${type}_delivery_option`}
    >
      <Icon />
      <Typography fontWeight={600} fontSize={12}>
        {name}
      </Typography>
      <Typography fontSize={12}>
        <Trans i18nKey={'unifiedBasket.message.itemsAmount'} values={{eligibleItems, totalItems}} />
      </Typography>
    </Box>
  );
};
